type VwoExperiment = {
  combination_chosen?: string | number;
};

type VwoWindow = Window & {
  _vwo_exp?: Record<string, VwoExperiment>;
  _vis_opt_queue?: Array<() => void>;
  _vis_opt_register_conversion?: (goalId: number, campaignId: number) => void;
};

const POLL_INTERVAL_MS = 200;
const POLL_TIMEOUT_MS = 10000;

export default function registerVwoConversion(conversionGoalId: number) {
  const win = window as VwoWindow;

  const tryRegisterConversion = (): boolean => {
    const experiments = win._vwo_exp;
    if (!experiments || Object.keys(experiments).length === 0) {
      return false;
    }

    let hasRegisteredConversion = false;

    Object.keys(experiments).forEach(key => {
      const experiment = experiments[key];
      if (experiment?.combination_chosen == null) {
        return;
      }

      const campaignId = Number(key);
      if (Number.isNaN(campaignId)) {
        return;
      }

      win._vis_opt_queue = win._vis_opt_queue || [];
      win._vis_opt_queue.push(() => {
        if (typeof win._vis_opt_register_conversion === "function") {
          win._vis_opt_register_conversion(conversionGoalId, campaignId);
        }
      });
      hasRegisteredConversion = true;
    });

    return hasRegisteredConversion;
  };

  const intervalId = window.setInterval(() => {
    if (tryRegisterConversion()) {
      window.clearInterval(intervalId);
      window.clearTimeout(timeoutId);
    }
  }, POLL_INTERVAL_MS);

  const timeoutId = window.setTimeout(() => {
    window.clearInterval(intervalId);
  }, POLL_TIMEOUT_MS);

  tryRegisterConversion();
}